import React from 'react';
import './ServerStatusIndicator.css';

export default function ServerStatusIndicator( props ) {
	return <div className={ 'ServerStatusIndicator ' + props.status } />;
}
